(() => {
  function getSectionId() {
    return document.querySelector('variant-picker')?.getAttribute('data-section-id') || null;
  }

  function getVariantId() {
    return document.querySelector('form[action*="/cart/add"] [name="id"]')?.value || null;
  }

  async function updateAll(variantId) {
    const sectionId = getSectionId();
    if (!sectionId || !variantId) return;

    const url = `${window.location.pathname}?variant=${variantId}&section_id=${sectionId}`;
    const res = await fetch(url, { credentials: 'same-origin' });
    if (!res.ok) return;

    const html = await res.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');

    document.querySelectorAll('.js-variant-metafield-line').forEach((el) => {
      const blockId = el.getAttribute('data-vml-block-id');
      const currentText = el.querySelector('[data-vml-text]');
      if (!blockId || !currentText) return;

      const newEl = doc.querySelector(`.js-variant-metafield-line[data-vml-block-id="${blockId}"] [data-vml-text]`);
      if (newEl) currentText.innerHTML = newEl.innerHTML;
    });
  }

  let last = null;

  function tick() {
    const v = getVariantId();
    if (v && v !== last) {
      last = v;
      updateAll(v);
    }
  }

  // Start
  document.addEventListener('DOMContentLoaded', () => {
    tick();
    setInterval(tick, 150);
  });

  // Also react fast on picker clicks (optional)
  document.addEventListener('click', (e) => {
    if (e.target.closest('variant-picker')) requestAnimationFrame(tick);
  });
})();